export default __webpack_public_path__ + "static/media/06 Track 6.47d6cc37.mp3";